export function budgetInPrincipleName(applicants: string) {
    return `Keyzy Budget in Principle - ${applicants}.pdf`;
}
